export default __webpack_public_path__ + "static/media/Nicole_Kolenda_AHV_In_Moms_We_Trust.31934f5c.jpg";